<template src="./Generic.html"></template>
<style src="./Generic.css" scoped></style>
<style>
#generic-map .ol-attribution {
  bottom: .5em !important;
  right: .5em !important;
}
</style>
<script>
// Generic imports
import Dashboard from './Dashboard.vue'
import NavBar from './NavBar.vue'
import MMP_LayerLegend from '../shared/MMP_LayerLegend.vue'
import Generic_ReleaseModal from './Generic_ReleaseModal.vue'
import Generic_LayerList from './Generic_LayerList.vue'
import Generic_Widgets from './Generic_Widgets.vue'
import Generic_Tools from './Generic_Tools.vue'
import Generic_Measurement from './Generic_Measurement.vue'
import Generic_ZoomLevel from './Generic_ZoomLevel.vue'
import Generic_Attributes from './Generic_Attributes.vue'
import Moveable from 'vue-moveable'
import DT_ChangePassword from '../Data_Tools/DT_ChangePassword.vue'
import MMP_LoadingScreen from '../shared/MMP_LoadingScreen.vue'

// Package Imports
import axios from 'axios'

// OpenLayers imports
import 'ol/ol.css'
import Attribution from 'ol/control/Attribution'
import Map from 'ol/Map'
import View from 'ol/View'
import { OSM, XYZ } from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { unByKey } from 'ol/Observable'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Style, RegularShape, Fill, Stroke } from 'ol/style'
import { get as projGet, fromLonLat, toLonLat, transform, transformExtent } from 'ol/proj'

import { createLayers, orderMapLayers } from './../../../utils/utils.js'
import { mapGetters } from 'vuex';

export default {
  name: 'Generic',
  components: {
    Dashboard,
    NavBar,
    MMP_LayerLegend,
    Generic_ReleaseModal,
    Generic_LayerList,
    Generic_Widgets,
    Generic_Tools,
    Generic_Measurement,
    Generic_ZoomLevel,
    Generic_Attributes,
    Moveable,
    DT_ChangePassword,
    MMP_LoadingScreen
  },
  data() {
    return {
      app: 'Home',
      dmpWhiteImg: require('../../../assets/dmpWhite.png'),
      user: null,
      versionReleaseInfo: null,
      isUshrUser: false,
      mapsMode: false,
      map: null,
      currentBaseMap: null,
      selectedExtent: null,
      drtLayersButtonsCtrl: [],
      wclLayersButtonsCtrl: [],
      ushrLayersButtonsCtrl: [],
      // Layer toggles shown in the Dashboard (vehicles map) layer panel.
      vehicleLayersButtonsCtrl: [],
      mmp_layersObj: {},
      spinnerManager: [],
      layerResponse: null,
      mmp_layers: [],
      lidarIsLoading: false,
      olMapMoveStartKey: null,
      olMapMoveEndKey: null,
      zoomStarted: null,
      zoomControlArr: null,
      shortTermLayerMemory: [],
      zoomEnded: null,
      zoomLevel: null,
      zoomLevelCap: 13,
      showLidarPanel: false,
      olImageLoadStartKey: null,
      olImageLoadEndKey: null,
      olImageLoadErrorKey: null,
      olTileLoadStartKey: null,
      olTileLoadEndKey: null,
      olTileLoadErrorKey: null,
      olSelectkey: null,
      legendImgSrc: null,
      layerLegendName: null,
      layerLegend: false,
      layerLegendMaxHeight: null,
      layerLegendMinimized: false,
      selectedRelease: null,
      extentResponse: [],
      showAttributes: false,
      attribResponse: [],
      attributesPanelMinimized: false,
      vectorLayer: null,
      attributesName: null,
      showMeasuringTool: false,
      clickedCoords: null,
      isAdmin: false,
      measurement: null,
      filterClassesObj: null,
      persistingLayerFilters: [],
      drtFlag: false,
      wclFlag: false,
      project_id: null,
      lidarMinZoomAchieved: false,
      distinct_lidar: [],
      extentName: null,
      features: [],
      feature_index: null,
      queryWindowResponse: null,
      fullSite: null,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        throttleDragRotate: 0
      },
      observer: null,
      prod :false,
      showLoadingScreen: true,
      menuCollapsed: false
    }
  },
  async mounted() {
    this.showLoadingScreen = true
    await this.initGeneric()
    this.showLoadingScreen = false
    if (!sessionStorage.pid && !typeof sessionStorage.pid == "string") {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      this.$emit('clearCurrentPositionsInterval')
      this.$router.push({ name: 'Login' })
    }
  },
  created() {
    window.addEventListener('beforeunload', this.handlerClose)
  },
  methods: {
    getReleaseVersion() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: { id: this.user.org }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkReleaseVersion API Call Error: ' + content.errors)
            } else {
              this.versionReleaseInfo = content[0]
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    toggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    },
    async reset(done) {
      await this.observer.disconnect();
      // Clear Lidar
      await this.clearLidar();
      await this.closeAttTable()
      await this.destroyMap();
      this.persistingLayerFilters = []
      this.lidarMinZoomAchieved = false;
      this.showLidarPanel = false;
      this.drtFlag = false;
      this.wclFlag = false;
      this.showLidarPanel = false;
      this.selectedRelease = null;

      done();
    },
    // Mirrors what the NavBar's own "Dashboard" click does (reset() then
    // vehiclesMap/initVehiclesMap) — used when a modal's close button backs
    // the user out to the dashboard instead of completing a selection.
    async showDashboard() {
      await new Promise(resolve => this.reset(resolve))
      this.initVehiclesMap()
    },
    toggleMeasuringTool() {
      this.showMeasuringTool = !this.showMeasuringTool
    },
    async getLayers(release) {
      this.drtLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      this.wclLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      this.ushrLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      this.drtLayersButtonsCtrl = []
      this.wclLayersButtonsCtrl = []
      this.ushrLayersButtonsCtrl = []
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/layer/release', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              // extent: release.extent_description,
              extent: this.selectedExtent,
              release_id: release.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('release API Call Error: ' + content.errors)
            } else {
              const layerLinks = []
              this.layerResponse = content
              content.filter(e => e.visibility != false).forEach(link => {
                let linkObj = link.link_object
                let linkObjLayerGroup = linkObj.info.layer_group
                // Replaces all underscores with spaces
                let output = linkObj.name.replace(/_/g, ' ')
                let objToPush = {
                  name: linkObj.name,
                  zoomControl: linkObj.zoomControl,
                  display_name: output,
                  layer_group: linkObjLayerGroup,
                  minZoom:
                    linkObj.minZoom == undefined ? null : linkObj.minZoom,
                  layer_definition:
                    linkObj.layerDefinition == undefined
                      ? null
                      : linkObj.layerDefinition,
                  fullMap: linkObj.fullMap
                }
                linkObj['display_name'] = output
                /* Render Geoserver WMS layers as 512px tiles (TileWMS512) rather
                than a single untiled ImageWMS request. Tiled layers are cacheable
                and render at fixed zoom resolutions, so they load faster and stay
                sharp (matching the MMP layer list). */
                if (linkObj.layerType === 'ImageWMS') {
                  linkObj.layerType = 'TileWMS512'
                }
                layerLinks.push(linkObj)
                // Push button for USHR layers
                if (linkObjLayerGroup == 'USHR') {
                  this.ushrLayersButtonsCtrl.push({
                    name: linkObj.name,
                    legendURL: linkObj.info.legend_url
                  })
                }
                // Push button for WCL and Analtyics Tool layers
                if (linkObjLayerGroup.includes('WCL')) {
                  this.wclLayersButtonsCtrl.push(objToPush)
                }
                if (linkObjLayerGroup.includes('DRT')) {
                  this.drtLayersButtonsCtrl.push(objToPush)
                }
              })

              this.mmp_layers = layerLinks
              this.mmp_layersObj = createLayers(this.mmp_layers, this.map)

              this.drtLayersButtonsCtrl.forEach(layerobj => {
                this.unloadLayers(layerobj.name)
              })
              this.wclLayersButtonsCtrl.forEach(layerobj => {
                this.toggleLayerVisibility(layerobj.name)
              })
              this.ushrLayersButtonsCtrl.forEach(layerobj => {
                this.unloadLayers(layerobj.name)
              })
              new unByKey(this.olMapMoveStartKey)
              new unByKey(this.olMapMoveEndKey)
              this.setListeners()
            }
          })
      } else {
        console.log('No User Token')
      }
    },
    setListeners() {
      this.olMapMoveStartKey = this.map.on('movestart', evt => {
        this.lidarIsLoading = true
        this.zoomStarted = this.map.getView().getZoom()
      })
      this.olMapMoveEndKey = this.map.on('moveend', evt => {
        this.zoomControlArr = this.zoomControlLayers(this.mmp_layersObj)
        this.zoomEnded = this.map.getView().getZoom()

        // Zoom controlled layer handling
        for (let i in this.zoomControlArr) {
          let zoomLayer = this.zoomControlArr[i]
          let layerIndex = this.shortTermLayerMemory.indexOf(
            zoomLayer.ButtonName
          )
          let layerRemembered = layerIndex != -1
          let item = document.getElementById(zoomLayer.ButtonName)
          let showLayer =
            zoomLayer.minZoom == null
              ? this.zoomEnded >= this.zoomLevelCap
              : this.zoomEnded >= zoomLayer.minZoom
          if (item) {
            // If user is zoomed in enough...
            if (showLayer) {
              /* If the layer exists in short term memory,
              remove it since the layer is being enabled. */
              if (layerRemembered) {
                this.toggleLayerVisibility(zoomLayer.ButtonName) // TODO: need this fn eventually
                this.shortTermLayerMemory.splice(layerIndex, 1)
              }
            } else {
              this.map.getLayers().forEach(layer => {
                if (layer.get('name') == zoomLayer.ButtonName) {
                  /* If turning the layer off, add it to short term layer
                  memory to be enabled again later. */
                  if (!layerRemembered) {
                    this.shortTermLayerMemory.push(zoomLayer.ButtonName)
                  }
                }
              })
              this.unloadLayers(zoomLayer.ButtonName)
            }
          }
        }
        // Lidar zoom warning handling
        if (this.showLidarPanel) {
          this.lidarDownload(this)
        }
        this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
      })
    },
    // This function generates the button list to be disabled even on zoom in and zoom out
    zoomControlLayers(layers) {
      let zoomAr = []
      for (let key in layers) {
        if (layers[key].zoomControl) {
          zoomAr.push({
            layer: layers[key].layer,
            ButtonName: key,
            minZoom:
              layers[key].minZoom == undefined ? null : layers[key].minZoom
          })
        }
      }
      return zoomAr
    },
    datasetSelected(release) {
      this.selectedRelease = release
      if (this.selectedRelease.extent_description != this.selectedExtent) {
        let extent = this.extentResponse.filter(e => e.extent_description == this.selectedRelease.extent_description)[0]
        this.changeExtent(extent)
      }
      this.selectedExtent = release.extent_description
      this.getLayers(release)
      this.$bvModal.hide('genericReleaseModal')
    },
    destroyMap() {
      if (this.map) {
        this.map.setTarget(null);
        this.map.getLayers().clear();
        this.map = null;
        this.drtLayersButtonsCtrl = []
        this.wclLayersButtonsCtrl = []
        this.ushrLayersButtonsCtrl = []
        this.vehicleLayersButtonsCtrl = []
      }
      this.closeLegend()
    },
    // Build the toggle list shown in the Dashboard's map layer panel from the
    // layers loaded for the vehicles map (release 25). Visibility mirrors what's
    // actually on the map right now (Trips + Current Positions default on).
    buildVehicleLayerButtons() {
      // Only surface the two vehicle-tracking layers in the panel; ignore any
      // other layers that ship in the release.
      const allowed = ['Current Positions', 'Trips']
      this.vehicleLayersButtonsCtrl = this.mmp_layers
        .filter(l => allowed.includes(l.name))
        .map(l => ({
          name: l.name,
          display_name: l.display_name || l.name.replace(/_/g, ' '),
          visible: this.checkLayer(l.name)
        }))
    },
    toggleVehicleLayer(name) {
      this.toggleLayerVisibility(name)
      const entry = this.vehicleLayersButtonsCtrl.find(l => l.name === name)
      if (entry) entry.visible = this.checkLayer(name)
    },
    reorderVehicleLayers(newOrder) {
      this.vehicleLayersButtonsCtrl = newOrder
      if (this.map && this.vehicleLayersButtonsCtrl.length) {
        orderMapLayers(this.mmp_layersObj, this.vehicleLayersButtonsCtrl, this.map)
      }
    },
    onDashboardMapResize() {
      // Dashboard map is maximized/minimized — re-measure so OpenLayers repaints to fit.
      this.$nextTick(() => {
        setTimeout(() => this.map?.updateSize(), 60)
      })
    },
    async initVehiclesMap() {
      // await this.reset();
      // this.mapsMode = false;
      // if (this.map) {
      //   await this.destroyMap();
      // }
      this.mapsMode = false;
      this.$nextTick(() => {
        this.map = new Map({
          controls: [new Attribution({ collapsible: true })],
          target: 'vehiclesMap',
          pixelRatio: 1,
          layers: [
            new TileLayer({
              source: new OSM(),
              name: 'OSM base layer',
              zIndex: 2
            })
          ],
          view: new View({
            center: [0, 0],
            zoom: 3,
            minZoom: 2,
            extent: projGet('EPSG:3857').getExtent(),
            constrainOnlyCenter: false,
            multiWorld: false
          }),
        });

        const mapDOMElement = document.getElementById('vehicleMapContainer')
        this.observer = new ResizeObserver(() => {
          this.map?.updateSize();
        })

        if (mapDOMElement) this.observer.observe(mapDOMElement)

        this.showZoomLevel()
      })

      this.$nextTick(async () => {
        let release = {
          id: 25
        }
        await this.getLayers(release); // Current Positions + Trips release ID
        this.toggleLayerVisibility('Trips')
        this.toggleLayerVisibility('Current Positions')
        this.buildVehicleLayerButtons()
        // This function assigns extent to the map for North America
        this.transformExtent(this.extentResponse)
      })
    },
    async initMaps() {
      // await this.reset();
      // if (this.map) {
      //   await this.destroyMap();
      // }
      this.mapsMode = true;
      this.$nextTick(() => {
        this.map = new Map({
          controls: [new Attribution({ collapsible: true })],
          target: 'generic-map',
          pixelRatio: 1,
          layers: [
            new TileLayer({
              source: new OSM(),
              name: 'OSM base layer',
              zIndex: 2
            })
          ],
          view: new View({
            center: [0, 0],
            zoom: 2,
            extent: projGet('EPSG:3857').getExtent(),
            constrainOnlyCenter: false,
            multiWorld: false
          }),
        });
        this.currentBaseMap = 'OpenStreetMap'

        this.showZoomLevel()

        this.map.getViewport().addEventListener('contextmenu', evt => {
          evt.preventDefault()
          let coords = toLonLat(this.map.getEventCoordinate(evt, 'EPSG:4326'))
          this.clickedCoords = coords // this will trigger copy function in DT_LatLong
        })

        const mapDOMElement = document.getElementById('generic-map')
        this.observer = new ResizeObserver(() => {
          this.map?.updateSize();
        })

        this.observer.observe(mapDOMElement)

        this.transformExtent(this.extentResponse)
      })
    },
    loadProject(project) {
      this.selectedRelease = null
      this.initMaps();
      if (!this.menuCollapsed) {
        this.toggleCollapse()
      }
      switch (project) {
        case 'DemoDRT':
          this.project_id = 21;
          this.wclFlag = false;
          this.drtFlag = true;
          this.prod=false;
          this.$bvModal.show('genericReleaseModal')
          break;
        case 'ProdDRT':
          this.project_id = 11;
          this.wclFlag = false;
          this.drtFlag = true;
          this.prod=true;
          this.$bvModal.show('genericReleaseModal')
          break;
        case 'WCL':
          this.project_id = 36;
          this.drtFlag = false;
          this.wclFlag = true;
          this.prod=false;
          this.$bvModal.show('genericReleaseModal')
          break;
      }
    },
    async initGeneric() {
      await this.getUser();
      await this.getExtent();
      await this.initVehiclesMap()
    },
    async getUser() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let info = response.data
            let auth = info.authorization
            this.user = {
              email: info.email,
              id: info.id,
              inactive: info.inactive,
              name: info.name,
              org: info.org,
              role: auth.permissions,
              test: auth.testAccount == 'True',
              group: auth.group,
              extent: info.extent_id != null ? info.extent_id : null,
              isAdmin: this.globalVerifyCurrentUserRole('USHR Platform Admin') || this.globalVerifyCurrentUserRole('PTV Admin'),
              tutorial_acknw: info.tutorial_acknw ? info.tutorial_acknw : {}
            }
            this.isUshrUser = info.org == 1
            // REFACTOR SUGGESTION -- WEBGIS-2548 -- self.user.errors is never going to be true here. Self.user is set above
            if (this.user.errors) {
              this.$router.push({ name: 'Login' })
            }
            if (this.user != null) {
              this.getReleaseVersion()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }

      return Promise.resolve(true)
    },
    handlerClose() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
    },
    unloadLayers(layerNameToToggle) {
      let layer
      if (this.mmp_layersObj[layerNameToToggle] != null) {
        layer = this.mmp_layersObj[layerNameToToggle].layer
      }

      if (layer) {
        // Unloading layer function
        this.map.removeLayer(layer)
        // Removes layer that has been turned off from spinnerManager
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      }
    },
    toggleLayerVisibility(layerNameToToggle) {
      if (layerNameToToggle == 'OSM') {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (!layer.get('name').includes('OSM')) {
              this.toggleBaseLayer('Azure')
            }
          }
        })
      } else {
        if (this.mmp_layersObj.hasOwnProperty(layerNameToToggle)) {
          const layer = this.mmp_layersObj[layerNameToToggle].layer

          // If the layer doesn't exist on the map, add it to the map
          if (!this.checkLayer(layer)) {
            this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)
            this.map.addLayer(layer)
            this.getLegend(layerNameToToggle)
          } else {
            this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
          }
        }
      }
    },
    toggleBaseLayer(newBaseLayer) {
      this.resetBaseLayer()
      this.currentBaseMap = newBaseLayer // REFACTOR SUGGESTION -- WEBGIS-2548 -- I feel like this could break something if newBaseLayer doesn't match any of the below options
      switch (newBaseLayer) {
        case 'OpenStreetMap':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'OSM base layer',
              zIndex: 2
            })
          )
          break
        case 'Azure':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${process.env.AZURE_MAPS_KEY}`,
                attributions: '© Microsoft Azure Maps',
                // Azure 'microsoft.imagery' tiles only exist up to zoom 19.
                // Cap the tile grid so OpenLayers over-zooms (upscales) the z19
                // tiles past 19 instead of requesting missing tiles (black map).
                maxZoom: 19
              }),
              name: 'Azure base layer',
              zIndex: 2
            })
          );
          break;
        case 'Black':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'Black base layer',
              zIndex: 2,
              opacity: 0
            })
          )
          break
      }
    },
    resetBaseLayer() {
      this.map.getLayers().forEach(layer => {
        if (layer != undefined && layer.get('name') != undefined) {
          if (layer.get('name').includes('base')) {
            if (this.checkLayer(layer)) {
              this.map.removeLayer(layer)
            }
          }
        }
      })
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] == layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name == layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle) {
      /* ImageWMS spinner addition and deletion */
      // Add layer to spinnerManager when image loads/refreshes
      this.olImageLoadStartKey = layer
        .getSource()
        .on('imageloadstart', event => {
          this.spinnerManager.push(layerNameToToggle)
        })
      // Remove layer from spinnerManager when image finishes loading
      this.olImageLoadEndKey = layer.getSource().on('imageloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if image encounters a loading error
      // NOTE - Image Load Error has spelling mistake -- should probably check that the correct event (with spelling mistake) is called
      this.olImageLoadErrorKey = layer
        .getSource()
        .on('imageloadeerror', event => {
          let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
          if (layerIndex != -1) {
            this.spinnerManager.splice(layerIndex, 1)
          }
        })

      /* TileWMS spinner addition and deletion */
      // Add layer to spinnerManager when tile loads/refreshes
      this.olTileLoadStartKey = layer.getSource().on('tileloadstart', event => {
        this.spinnerManager.push(layerNameToToggle)
      })
      // Remove layer from spinnerManager when tile finishes loading
      this.olTileLoadEndKey = layer.getSource().on('tileloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if tile encounters a loading error
      this.olTileLoadErrorKey = layer.getSource().on('tileloaderror', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
    },
    toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle) {
      // Removes layer listeners
      new unByKey(this.olImageLoadStartKey)
      new unByKey(this.olImageLoadEndKey)
      new unByKey(this.olImageLoadErrorKey)
      new unByKey(this.olTileLoadStartKey)
      new unByKey(this.olTileLoadEndKey)
      new unByKey(this.olTileLoadErrorKey)
      // Removes layer that has been turned off from spinnerManager
      let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      while (layerIndex != -1) {
        this.spinnerManager.splice(layerIndex, 1)
        layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      }
      this.map.removeLayer(layer)
    },
    // This function fetches the legends for each layer for DRT on button click
    getLegend(layerName) {
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == layerName) {
          // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
          let layerUrl = layer
            .getSource()
            .getLegendUrl(this.map.getView().getResolution())
          if (layerUrl) {
            this.legendImgSrc = `${layerUrl}&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;` + '&authkey=' + sessionStorage.token
            this.layerLegendName = layerName
            // After setting legend URL, show legend component
            this.layerLegend = true
          } else {
            console.log('FAILED TO FIND URL FOR LEGEND.')
          }
        }
      })
    },
    maxOrMinLegend(bool) {
      this.layerLegendMinimized = bool
    },
    closeLegend() {
      this.layerLegend = false
    },
    getExtent() {
      if (sessionStorage.token) {
        /* This API call is made to get the response for extent at
        initialization which we can sort further as required.
        This will reduce the additional trip to the backend. */
        axios
          .get(process.env.API_LOCATION + '/api/users/getAllExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllExtents API Call Error: ' + content.errors)
            } else {
              this.extentResponse = []
              content.forEach(element => {
                this.extentResponse.push(element)
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async transformExtent(extArray) {
      let extentValues = []
      let extentCenter = []
      let arr

      // Assign customized extent
      switch (this.selectedExtent) {
        // REFACTOR -- WEBGIS-2548 -- Commented out unused switch case options
        // REFACTOR SUGGESTION -- WEBGIS-2548 -- Should there be an option for Middle East??
        // case '"North America"':
        // case '"Continental United States"':
        default:
          arr = extArray.filter(e => e.extent_description == 'North America')
          break
        case '"Europe"':
          arr = extArray.filter(e => e.extent_description == 'Europe')
          break
        case '"Middle East"':
          arr = extArray.filter(e => e.extent_description == 'Middle East')
          break
        case '"Japan"':
          arr = extArray.filter(e => e.extent_description == 'Japan')
          break
      }

      // Need to convert the string into array of numbers for passing to the transformExtent function
      arr[0].extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      arr[0].extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })

      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view;
      view = new View({
        extent: coord,
        center: center,
        zoom: 3,
        minZoom: 3,
        multiWorld: true,
        constrainOnlyCenter: true
      })

      this.map.setView(view)
    },
    changeExtent(selectedExtent) {
      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers for passing
      to the transformExtent function. */
      selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view = new View({
        extent: coord,
        center: center,
        zoom: 4,
        minZoom: 3,
        multiWorld: true,
        constrainOnlyCenter: true
      })

      this.map.setView(view)
    },
    widgetExtentChanged(extent) {
      this.changeExtent(extent)
      this.selectedExtent = extent.extent_description
    },
    getShowAttributes(data) {
      this.showAttributes = data
      if (!this.showAttributes) {
        // Removes circle that appears on map when user inputs coordinates to zoom to
        this.map.removeLayer(this.vectorLayer)
        this.vectorLayer = null
      }
    },
    // Loads attributes for all layer
    loadAttributes(attr) {
      let obj = attr.name
      let layer_group = attr.layer_group
      let layerResponse = attr.response
      let layerobj = null
      if (this.mmp_layersObj.hasOwnProperty(obj)) {
        layerobj = layerResponse.filter(c => {
          return (
            c.link_object.info != undefined &&
            c.link_object.info.layer_group == layer_group
          )
        })
      }
      if (layerobj != null) {
        let param = layerobj.filter(c => c.link_object.name == obj)
        if (param.length != 0) {
          /* unByKey function will disable all single-click events
          for layers other than the selected layer */
          new unByKey(this.olSelectkey)
          // This check provides dynamic names to attributes window
          this.attributesName = param[0].layer_name.replace(/_/g, ' ')
          this.olSelectkey = this.map.on('singleclick', evt => {
            if (!this.showMeasuringTool) {
              this.querySite(
                evt,
                this.mmp_layersObj[obj].layer,
                this.map,
                param[0].link_object.params.LAYERS
              )
            }
          })
        }
      }
    },
    removeAttributesWindowListener() {
      new unByKey(this.olSelectkey);
      this.olSelectkey = null;
    },
    querySite(evt, layers, map, geoserverName, cqlFilter = null) {
      const source = layers.getSource()
      if (!cqlFilter) {
        cqlFilter = source.getParams().CQL_FILTER
      }
      const viewResolution = map.getView().getResolution()
      const options = {
        INFO_FORMAT: 'application/json',
        LAYERS: geoserverName,
        CQL_FILTER: 'INCLUDE' + `${cqlFilter ? ` AND ${cqlFilter}` : ''}`,
        QUERY_LAYERS: geoserverName,
        VIEWPARAMS: null
      }
      let url =
        source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          options
        ) + '&FEATURE_COUNT=100&buffer=5&format_options=callback:getJsonFeature&authkey=' + sessionStorage.token

      if (sessionStorage.token) {
        axios
          .get(url, {})
          .then(response => {
            if (response.data.features.length > 0) {
              this.attribResponse = []
              this.features = []
              this.feature_index = 0
              this.queryWindowResponse = []
              this.queryWindowResponse = response
              this.populateQueryWindow(response, 'IMAGE', geoserverName)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    showNextAttribute(value) {
      this.feature_index = value
      this.populateQueryWindow(this.queryWindowResponse, 'IMAGE')
    },
    populateQueryWindow(response, layerType, geoserverName = null) {
      let clickedLayerName
      let data = response.data
      let checkAdditionalSegment
      let site
      if (layerType == 'IMAGE') {
        this.features = data.features
        // REFACTOR -- WEBGIS-2548 -- this is not a variable in MMP.vue. Added it.
        this.fullSite = this.features[this.feature_index]
        site = this.features[this.feature_index].properties
      }
      clickedLayerName = this.features[this.feature_index]['id']
      this.clickedLayerName = clickedLayerName
      if (clickedLayerName) {
        clickedLayerName = clickedLayerName.split('.')[0]
        clickedLayerName = clickedLayerName.substr(0, 1).toUpperCase() + clickedLayerName.substr(1, clickedLayerName.length)
        this.showAttributes = true
      }
      this.attribResponse = []
      for (let key in site) {
        if (site.hasOwnProperty(key)) {
          this.attribResponse.push({
            value: site[key],
            name: key
          })
        }
      }

      // Get array of coordinates. Will be 2D array for linestrings.
      let geomCoordinates = this.fullSite.geometry.coordinates
      // Get length 2 array of coordinates and store them in featureCoordinates
      let featureCoordinates =
        geomCoordinates.length > 2
          ? geomCoordinates[Math.round(geomCoordinates.length / 2)]
          : geomCoordinates
      // Remove previous vectorLayer from the map
      this.map.removeLayer(this.vectorLayer)

      let coords = new fromLonLat(featureCoordinates, 'EPSG:4326')

      // Create vector layer of clicked feature
      this.addHexagonSymbolizer(coords)
    },
    handleDrag({ target, transform }) {
      target.style.transform = transform
    },
    maxOrMinAttributes(bool) {
      this.attributesPanelMinimized = bool
    },
    closeAttTable() {
      this.showAttributes = false
      this.attribResponse = null
      // Removes circle that appears on map when user inputs coordinates to zoom to
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
    },
    async addHexagonSymbolizer(featureCoordinates) {
      // Create point vector layer (hexagon) of clicked feature
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              type: 'geoMarker',
              geometry: new Point(
                featureCoordinates
              )
            })
          ]
        }),
        zIndex: 1000,
        style: new Style({
          image: new RegularShape({
            points: 6, // Number of points for the hexagon
            radius: 14, // Radius of the hexagon
            fill: new Fill({ color: 'rgba(6, 60, 109, 0.2)' }), // Fill color
            stroke: new Stroke({ color: '#00008B', width: 2 }), // Border color and width
          })
        })
      })

      this.map.addLayer(this.vectorLayer)
    },
    async putLayerOnTop(data) {
      this.drtLayersButtonsCtrl = this.putLayerOnTopHelper(
        this.drtLayersButtonsCtrl,
        data.payload.layerName
      )

      data.resolve();
    },
    putLayerOnTopHelper(arr, layerName) {
      for (let layerIndex in arr) {
        let layer = arr[layerIndex]
        if (layer.display_name == layerName || layer.name == layerName) {
          // Removes layer from array
          arr.splice(layerIndex, 1)
          // Adds layer back at the beginning of the array
          arr.unshift(layer)
          break
        }
      }
      return arr
    },
    toggleLidarPanel(evt = null) {
      this.toggleLidarDownload()
      this.showLidarPanel = !this.showLidarPanel
    },
    setLidarMinZoomAchieved(bool) {
      this.lidarMinZoomAchieved = bool
    },
    toggleLidarDownload() {
      // Lidar was off, turning it on
      if (!this.showLidarPanel) {
        this.getMapExtent()
        this.lidarDownload(this)
        // this.onResizeLidar()
        // Else lidar is on, turning it off
      } else {
        // Hide any lidar on map, clear moveend listener, clear distinct_lidar arr
        this.clearLidar()
      }
    },
    clearLidar() {
      let lidarLayersToRemove = []
      // Get the lidar layers
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name')
          ? layer.get('name').toString()
          : null
        if (layerNameStr && layerNameStr.includes('lidar')) {
          lidarLayersToRemove.push(layer)
        }
      })
      // Remove the lidar layers
      lidarLayersToRemove.forEach(layer => {
        this.map.removeLayer(layer)
      })

      // Clear distinct lidar arr
      this.distinct_lidar = []
    },
    getMapExtent() {
      this.extentName = this.selectedExtent
        ? this.selectedExtent
        : JSON.parse(sessionStorage.Extent)
    },
    lidarDownload: async self => {
      // let time = new Date().getTime() // REFACTOR SUGGESTION -- WEBGIS-2548 -- this is never used.
      // Only check for lidar if at appropriate zoom level
      if (self.zoomEnded >= 17) {
        // Turn on Lidar spinner since no data has loaded
        self.lidarIsLoading = true

        // Calculate users view extent
        let extent = self.map.getView().calculateExtent(self.map.getSize())
        // Transform extent from OSM format to lat/lon coords
        // EPSG:3857 - 'This is projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc.' https://epsg.io/3857
        // EPSG:4326 - 'Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.' https://epsg.io/4326
        let userExtentBoxCoords = new transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )
        let apiUrl
        switch (self.extentName) {
          case 'Japan':
            apiUrl = '/api/drt/available_lidar_japan'
            break
          case 'North America':
            apiUrl = '/api/drt/available_lidar'
            break
          case 'Europe':
            apiUrl = '/api/drt/available_lidar_europe'
            break
          case 'Middle East':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Kuwait':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Saudi Arabia':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
        }
        if (sessionStorage.token) {
          await axios
            .get(process.env.API_LOCATION + apiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              // Four corners of users view
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            })
            .then(response => {
              const content = response.data
              // If duplicate entry found, throw error and prevent submission
              if (content.errors) {
                console.log('API Call Error: ' + content.errors)
              } else {
                // Grab any expanded groups
                let expanded = []
                self.distinct_lidar.forEach(lidar => {
                  if (!lidar.groupIsCollapsed) {
                    expanded.push(lidar.dateCode)
                  }
                })
                // Clearing distinct lidar after the new call has been returned
                // reduces user interface interruption
                self.distinct_lidar = []

                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        // autoLoad: self.ansiComponent ? true : false
                      })
                    }

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        //autoLoad: self.ansiComponent ? true : false
                      })
                    }
                  }
                })

                // Now that we have distinct lidar dates extracted in this.distinct_lidar, we can build sub nav
                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)
                  }
                })

                // Sort distinct_lidar array so newest lidar is in index 0 and displayed first in the lidar subnav buttons
                self.distinct_lidar.sort((a, b) => {
                  return parseInt(b.dateCode) - parseInt(a.dateCode)
                })

                // Re expand any previously expanded groups
                // For each lidar group, check if matches any item in expanded array we created
                self.distinct_lidar.forEach(lidar => {
                  expanded.forEach(expandedGroupDateCode => {
                    // If match between distinct lidar group and a group that was previously expanded, re expand group
                    if (expandedGroupDateCode == lidar.dateCode) {
                      lidar.groupIsCollapsed = false
                    }
                  })
                })
                // Turn off Lidar spinner now that data has loaded
                self.lidarIsLoading = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
        // Else user needs to zoom in further to access lidar
      } else {
        // Clear any lidar groups, since nothing is available at users current zoom
        self.distinct_lidar = []
        self.clearLidar()
        self.lidarIsLoading = false
      }
    },
    showZoomLevel() {
      this.map.on('moveend', evt => {
        this.zoomLevel = this.map.getView().getZoom()
      })
    },
    async addPoint(feature) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature]
        }),
        zIndex: 1000
      })

      this.map.addLayer(this.vectorLayer)
    },
  },
  computed: {
    ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed', 'globalVerifyCurrentUserRole'])
  }
}
</script>
